export const VERCEL_AI_MODELS = [
  { id: "claude-haiku", label: "claude-haiku", cost: "≈$0.01/run" },
  { id: "claude-sonnet", label: "claude-sonnet", cost: "≈$0.03/run" },
  { id: "claude-opus", label: "claude-opus", cost: "≈$0.15/run" },
  { id: "gpt-5-codex", label: "gpt-5-codex", cost: "≈$0.03/run" },
  { id: "qwen397", label: "qwen397", cost: "≈$0.01/run" },
  { id: "qwen27", label: "qwen27", cost: "≈$0.01/run" },
  { id: "deepseek-flash", label: "deepseek-flash", cost: "≈$0.01/run" },
  { id: "gemma-31b", label: "gemma-31b", cost: "≈$0.01/run" },
  { id: "kimi-k2", label: "kimi-k2", cost: "≈$0.02/run" },
  { id: "glm-5", label: "glm-5", cost: "≈$0.02/run" },
  { id: "minimax-m2", label: "minimax-m2", cost: "≈$0.02/run" },
  { id: "gemini-flash", label: "gemini-flash", cost: "≈$0.01/run" },
] as const;

export type VercelAiModel = (typeof VERCEL_AI_MODELS)[number]["id"];

export function modelCostLabel(model: VercelAiModel): string {
  return VERCEL_AI_MODELS.find((m) => m.id === model)?.cost ?? "≈$0.01/run";
}
